<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

export default {

  name: 'AppearanceWrapper',

  data () {
    return {
      visible: false,
      hook: 0.5
    }
  },

  computed: {
    height () {
      return this.$store.state.app.window.height
    },

    child () {
      return this.$children.length > 0
        ? this.$children[0]
        : null
    }
  },

  watch: {
    '$store.state.app.window.scroll': 'onScroll'
  },

  mounted () {
    this.prepare()
    this.$nextTick(() => {
      this.onScroll()
    })
  },

  methods: {
    onScroll () {
      if (this.visible || !this.child) return

      const bb = this.child.hasOwnProperty('getBoundingClientRect')
        ? this.child.getBoundingClientRect()
        : this.child.$el.getBoundingClientRect()

      const visible = bb.top <= this.height * this.hook

      if (visible) {
        this.visible = visible
        this.animate()
      }
    },

    prepare () {
      if (this.child.hasOwnProperty('beforeAppear')) {
        this.child.beforeAppear()
      }
    },

    animate () {
      if (this.child.hasOwnProperty('appear')) {
        this.child.appear()
      }
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

transition
  slot

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>



</style>



// WEBPACK FOOTER //
// appearance-wrapper.vue?5557d22c